<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">老干工单待作废</p>
        </div>
        <slot name="statistics"></slot>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <!-- <el-button
          style="float: right; padding: 3px 0; color: #000"
          type="text"
          @click="Reset"
        >
          <i class="el-icon-refresh"></i>
          刷新页面
        </el-button> -->
                <i
                    class="searchDomw"
                    @click="isSearchContent = !isSearchContent"
                    :class="
                        isSearchContent == true
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                    "
                ></i>
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <QueryForm
                        @QuerySearch="QuerySearch"
                        :queryForm="queryForm"
                    ></QueryForm>
                </div>
                <!-- <div class="arrowDown">
          <i
            :class="
              isSearchContent === true
                ? 'el-icon-arrow-up'
                : 'el-icon-arrow-down'
            "
            style="color: #000"
            @click="isSearchContent = !isSearchContent"
          ></i>
        </div> -->
            </div>
        </div>
        <!-- <global-tag>
            <span slot="title">老干工单待作废</span>
            <div class="search" slot="search">
                <QueryForm
                    @QuerySearch="QuerySearch"
                    :queryForm="queryForm"
                ></QueryForm>
            </div>
        </global-tag> -->

        <div style="height: 20px"></div>
        <div style="display: none">
            <input
                @change="(e) => uploadInfo(e, '4')"
                id="speechUpload"
                type="file"
            />
        </div>
        <!--        <label for="speechUpload" class="labelImportBtn">-->
        <!--            <span>导入</span>-->
        <!--        </label>-->
        <el-button
            type="primary"
            icon="el-icon-download"
            class="button downOutBtns"
            @click="createExcel"
            >导出
        </el-button>
        <el-button icon="el-icon-delete" type="danger" @click="batchDelete"
            >批量作废
        </el-button>
        <div style="height: 20px"></div>

        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
                @selection-change="handleSelectionChange"
            >
                <el-table-column type="selection" width="50" align="center">
                </el-table-column>
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="orderNum"
                    label="工单流水号"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="visitResults"
                    label="回访结果"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                    <template slot-scope="scope">
                        <p v-if="scope.row.visitResults == null">
                            <span v-if="scope.row.results == 0">合格</span>
                            <span v-else-if="scope.row.results == 1"
                                >不合格</span
                            >
                            <span v-else-if="scope.row.results == 3"
                                >虚假工单</span
                            >
                            <span v-else>作废</span>
                        </p>
                        <p v-else>
                            <span v-if="scope.row.visitResults == 0">合格</span>
                            <span v-else-if="scope.row.visitResults == 1"
                                >不合格</span
                            >
                            <span v-else-if="scope.row.visitResults == 3"
                                >虚假工单</span
                            >
                            <span v-else>作废</span>
                        </p>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="customerName"
                    label="客户姓名"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="联系地址"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="customerphone"
                    label="联系方式"
                    align="center"
                    width="150"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    prop="servetypename"
                    label="服务类别"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeStart"
                    label="服务开始时间"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="timeEnd"
                    label="服务结束时间"
                    align="center"
                    width="220"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="realPeriod"
                    label="时间工作时间/分钟"
                    align="center"
                    width="180"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="estimateLevel"
                    :formatter="estimateLevelFormat"
                    label="客户满意度"
                    align="center"
                    width="120"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                    :show-overflow-tooltip="true"
                    width="150"
                    fixed="right"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="detailsVisit('查看', scope.row)"
                            >查看</el-button
                        >
                        <el-button type="text" @click="cancellation(scope.row)"
                            >作废</el-button
                        >
                        <!--            <el-button type="text" @click="chehui(scope.row)">撤回</el-button>-->
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog
            title="审核"
            :visible.sync="dialogVisible"
            width="50%"
            :before-close="handleClose"
            :close-on-click-modal="false"
        >
            <el-form ref="form" :model="auditForm" label-width="140px">
                <el-form-item label="审核作废的理由：">
                    <el-input
                        type="textarea"
                        v-model="auditForm.closeReason"
                    ></el-input>
                </el-form-item>
                <el-form-item label="提交人：">
                    <el-input v-model="auditForm.askCloseName"></el-input>
                </el-form-item>
                <el-divider></el-divider>

                <el-form-item label="审核状态：">
                    <el-radio-group v-model="auditForm.auditActive">
                        <el-radio :label="1">审核通过</el-radio>
                        <el-radio :label="2">审核不通过</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="审核意见：">
                    <el-input
                        type="textarea"
                        v-model="auditForm.checkIdea"
                    ></el-input>
                </el-form-item>
            </el-form>

            <div
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 15px;
                "
            >
                <el-button type="primary" @click="auditSend" :disabled="isAbled"
                    >确 定</el-button
                >
                <el-button @click="handleClose">取 消</el-button>
            </div>
        </el-dialog>
        <div style="height: 20px"></div>
        <div>
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10, 20, 40, 100]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
            >
            </el-pagination>
        </div>
        <VisitDialog
            ref="visitDialog"
            @updateList="getDataList"
            :show-visit.sync="showVisit"
            :showTitle="showTitle"
            :orderInfo="orderInfo"
        ></VisitDialog>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import QueryForm from "@/component/queryform.vue"
// import globalTag from "../../components/globalTag"
import VisitDialog from "../component/visitDialog.vue"
import headLine from "../../components/headline"

export default {
    components: {
        // globalTag,
        QueryForm,
        VisitDialog,
        headLine,
    },
    data() {
        return {
            isSearchContent: true,
            showVisit: false,
            showTitle: "",
            queryForm: {
                orderName: "",
                customerType: "",
                serveproductName: "",
                servestationName: "",
                servePersonName: "",
            },
            dialogVisible: false,
            tableData: [],
            orderInfo: {
                customerName: "",
            },
            totalCount: 0,
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            auditForm: {
                closeReason: "",
                askCloseName: "",
                checkIdea: "",
                auditActive: "",
            },
            selectData: {},
            multipleSelection: [],
            isAbled: false,
        }
    },
    created() {
        this.getDataList()
    },
    methods: {
        Reset() {
            this.queryForm = {}
            this.getDataList()
        },
        // 发送作废申请
        auditSend() {
            this.isAbled = true
            const loading = this.$loading({
                lock: true,
                text: "Loading",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            })
            if (this.auditForm.auditActive === 1) {
                // 审核通过 进行作废
                this.selectData.states = "5"
                request({
                    url: "/jjyl/servicePgd/info/End",
                    method: "POST",
                    data: this.selectData,
                }).then((res) => {
                    if (res.code === 200) {
                        loading.close()
                        this.$message.success("作废成功")
                    } else {
                        loading.close()
                        this.$message.error("作废失败")
                    }
                    this.handleClose()
                    this.getDataList()
                }).catch((error) => {
                    loading.close()
                    this.handleClose()
                })
            } else if (this.auditForm.auditActive === 2) {
                // 审核不通过 进行撤回
                this.selectData.closeReason = null
                this.selectData.askCloseName = null
                request({
                    url: "/jjyl/servicePgd/info/withdraw",
                    method: "POST",
                    data: this.selectData,
                }).then((res) => {
                    if (res.code === 200) {
                         loading.close()
                        this.$message.success("撤回成功")
                    } else {
                        loading.close()
                        this.$message.error("撤回失败")
                    }
                    this.handleClose()
                    this.getDataList()
                }).catch((error) => {
                    loading.close()
                    this.handleClose()
                })
            } else {
                this.$message.error("请选择审核是否通过")
                this.isAbled = false
            }
        },
        // 作废弹框关闭
        handleClose() {
            this.dialogVisible = false
            this.auditForm = {}
            this.selectData = {}
        },
        // 显示作废弹框
        cancellation(data) {
            this.isAbled = false
            this.auditForm = {
                closeReason: data.closeReason || "",
                askCloseName: data.askCloseName,
                checkIdea: "",
                auditActive: "",
            }
            this.selectData = data
            this.dialogVisible = true
        },
        // 点击撤回
        chehui(row) {
            this.$confirm("此操作将撤回该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                // 修改状态为待派发
                // row.states = '0'
                // 移除作废理由
                row.closeReason = null
                // 移除作废申请人
                row.askCloseName = null
                request({
                    url: "/jjyl/servicePgd/info/withdraw",
                    method: "POST",
                    data: row,
                }).then((res) => {
                    console.log(res)
                    if (res.code === 200) {
                        this.$message.success("撤回成功")
                    } else {
                        this.$message.error("撤回失败")
                    }
                    this.getDataList()
                })
            })
        },
        mobandaochu() {
            this.request2({
                url: "/jjyl/servicePgd/info/Templatedownload",
                method: "POST",
                data: {
                    pageNo: this.query.pageNum,
                    pageSize: this.query.pageSize,
                },
                responseType: "blob",
            }).then((resp) => {
                if (resp) {
                    const blob = new Blob([resp], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "模板导出.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出成功")
                }
            })
        },
        createExcel() {
            this.request2({
                url: "/jjyl/servicePgd/info/export",
                method: "POST",
                excel: true,
                data: {
                    customerphone: this.queryForm.customerphone,
                    pageNo: this.query.pageNo,
                    pageSize: this.query.pageSize,
                    orderNum: this.queryForm.orderNum,
                    states: "4",
                    type: this.queryForm.customerType || "4",
                    // customerType: this.queryForm.customerType,
                    customerName: this.queryForm.customerName,
                    timeStart: this.queryForm.timeStart,
                    timeEnd: this.queryForm.timeEnd,
                    position: this.queryForm.position,
                    servestationName: this.queryForm.servestationName,
                    serveproductName: this.queryForm.serveproductName,
                    servePersonName: this.queryForm.servePersonName,
                },
                responseType: "blob",
            }).then((res) => {
                if (res) {
                    const blob = new Blob([res], {
                        type: "application/vnd.ms-excel",
                    })
                    const fileName = "老干工单.xls"
                    const linkNode = document.createElement("a")
                    linkNode.download = fileName //a标签的download属性规定下载文件的名称
                    linkNode.style.display = "none"
                    linkNode.href = URL.createObjectURL(blob) //生成一个Blob URL
                    document.body.appendChild(linkNode)
                    linkNode.click() //模拟在按钮上的一次鼠标单击
                    URL.revokeObjectURL(linkNode.href) // 释放URL 对象
                    document.body.removeChild(linkNode)
                    this.$message.success("导出表格成功")
                }
            })
        },
        async fileChange(event) {
            const file = event.target.files[0]
            const personType = "1"
            let config = {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
            let formData = new FormData()
            formData.append("personType", personType)
            formData.append("file", file)
            let result = await this.$http.post(
                "/jjyl/servicePgd/info/ServicePgdExcel",
                formData,
                config
            )
            // 清空文件
            const fileEle = document.getElementById("speechUpload")
            fileEle.value = ""
            if (result.code === 200) {
                this.$message.success(result.message)
                this.getDataList()
            } else {
                this.$message.warning(result.message)
            }
        },
        getDataList() {
            let params = {
                customerphone: this.queryForm.customerphone,
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                orderNum: this.queryForm.orderNum,
                // states: "4",
                pgdStates: ["4", "8"],
                type: this.queryForm.customerType || "4",
                customerUserType: this.queryForm.customerUserType,
                customerName: this.queryForm.customerName,
                timeStart: this.queryForm.timeStart,
                timeEnd: this.queryForm.timeEnd,
                position: this.queryForm.position,
                provinceId: this.queryForm.provinceId,
                cityId: this.queryForm.cityId,
                areaId: this.queryForm.areaId,
                streetId: this.queryForm.streetId,
                communityId: this.queryForm.communityId,
                servestationName: this.queryForm.servestationName,
                serveproductName: this.queryForm.serveproductName,
                servePersonName: this.queryForm.servePersonName,
                city: "",
                zone: "",
                street: "",
                shequ: "",
            }
            request({
                url: "/jjyl/servicePgd/info/findServicepgd",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        this.tableData = res.content.list
                        this.totalCount = res.content.count
                    } else {
                        this.tableData = []
                        this.totalCount = 0
                    }
                }
            })
        },
        statesFormat(row, column) {
            if (row.states === 0) {
                return "待派发"
            } else if (row.states === 1) {
                return "待处理"
            } else if (row.states === 2) {
                return "待回访"
            } else if (row.states === 3) {
                return "服务完成"
            } else if (row.states === 4) {
                return "待作废"
            } else if (row.states === 5) {
                return "已作废"
            } else if (row.states === 100) {
                return "移动终端接单"
            }
        },
        estimateLevelFormat(row, column) {
            if (row.estimateLevel === "1") {
                return "没有服务"
            } else if (row.estimateLevel === "2") {
                return "不满意"
            } else if (row.estimateLevel === "3") {
                return "服务一般"
            } else if (row.estimateLevel === "4") {
                return "基本满意"
            } else if (row.estimateLevel === "5") {
                return "非常满意"
            }
        },
        async detailsVisit(title, row) {
            if (title === "新增") {
                this.showTitle = title
                this.showVisit = true
            } else {
                this.showTitle = title
                await this.getDetails(row.id)
                this.showVisit = true
            }
            // 获取服务类型
            this.$refs.visitDialog &&
                this.$refs.visitDialog.getServiceTypeList()
            // 获取套餐类型
            this.$refs.visitDialog && this.$refs.visitDialog.getEnsureList()
        },
        getDetails(id) {
            request({
                url: "/jjyl/servicePgd/info/findServicepgdById",
                method: "POST",
                data: {
                    id: id,
                },
            }).then((res) => {
                if (res.code === 200) {
                    if (res.content) {
                        this.orderInfo = res.content
                    } else {
                        this.orderInfo = {}
                    }
                }
            })
        },
        QuerySearch() {
            this.getDataList()
        },
        handleSelectionChange(rows) {
            this.multipleSelection = rows
        },
        batchDelete() {
            var that = this
            var val = this.multipleSelection
            if (val.length > 0) {
                this.$confirm("确认批量作废吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url: "/jjyl/servicePgd/info/End",
                                method: "POST",
                                data: {
                                    id: item.id,
                                    orderNum: item.orderNum,
                                    states: 5,
                                },
                            })
                        })
                    })
                    .then(() => {
                        this.$message({
                            type: "success",
                            message: "批量作废成功!",
                        })
                        setTimeout(() => this.getDataList(), 500)
                    })
            } else {
                this.$confirm("请选择要作废的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },
        handleSizeChange(val) {
            this.query.pageSize = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            this.query.pageNo = val
            this.getDataList()
        },
    },
}
</script>

<style lang="less" scoped>
.QuerySearchBtn {
    margin-left: 60px;
}

.cancellationBox {
    display: flex;
    justify-items: center;
}

.table-operation {
    width: 100%;
    display: flex;
    cursor: pointer;
    justify-content: center;

    div {
        flex: 1;
    }
}

.labelImportBtn {
    margin: 0 10px;

    span {
        width: 70px;
        height: 40px;
        text-align: center;
        display: inline-block;
        line-height: 40px;
        font-size: 14px;
        background-color: #409eff;
        cursor: pointer;
        color: #ffffff;
        border-radius: 5px;
    }
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    .search_head {
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 15px 20px 0px 5px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
}
.searchDomw {
    cursor: pointer;
}
</style>
